import React, { FormEvent, FunctionComponent, ReactNode } from 'react'
import styles from './style.module.css'
import { useDesignLanguagePerClass } from '@afterpaytouch/core'

// Unstable component - Specification is not finalised.
// Potential design system candidate
export interface FormProps {
  onSubmit?: (e: FormEvent) => any
  testNameSpace?: string
  children: ReactNode
}

export const Form: FunctionComponent<FormProps> = ({ onSubmit, children, testNameSpace = '' }) => {
  const designLanguageClass = useDesignLanguagePerClass(styles)

  return (
    <form
      onSubmit={onSubmit}
      className={designLanguageClass.form}
      noValidate={true}
      {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-form` })}
    >
      {children}
    </form>
  )
}
